<template>
    <div v-if="loading">
        <SpinnerIOS />
    </div>
    <div v-else class="container">
        <div class="row row-cols-1 row-cols-md-4 g-4 section-cards">
            <div class="col" v-for="news in dataNews" :key="news.id">
                <div
                    class="card h-100 shadow-sm border-0 rounded-3 overflow-hidden"
                    style="cursor: pointer"
                    @click="goToDetail(news.id)"
                >
                    <div class="position-relative">
                        <img
                            class="card-img-top"
                            :src="news.image || '/media/default_thumbnail.jpg'"
                            :alt="news.title"
                            style="object-fit: cover; height: 180px;"
                        />
                        <div
                            class="overlay position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                        >
                            <i class="bi bi-file-earmark-text text-white fs-3"></i>
                        </div>
                    </div>
                    <div class="card-body">
                        <h5 class="card-title text-truncate fw-bold" :title="news.title">
                            {{ news.title.length > 50 ? news.title.slice(0, 50) + '...' : news.title }}
                        </h5>
                    </div>
                    <div class="card-footer bg-transparent border-0">
                        <small class="text-muted">{{ formatDate(news.created_at) }}</small>
                    </div>
                </div>
            </div>
        </div>
        <nav v-if="pagination.totalPages > 1" class="mt-4 d-flex justify-content-center">
            <ul class="pagination">
                <li class="page-item" :class="{ disabled: pagination.currentPage === 1 }">
                    <a class="page-link" href="#" @click.prevent="changePage(pagination.currentPage - 1)">
                        <i class="bi bi-skip-backward"></i>
                    </a>
                </li>
                <li
                    class="page-item"
                    v-for="(page, index) in paginationPages"
                    :key="index"
                    :class="{ active: page === pagination.currentPage, disabled: page === '...' }"
                >
                    <a v-if="page !== '...'" class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                    <span v-else class="page-link">...</span>
                </li>
                <li class="page-item" :class="{ disabled: pagination.currentPage === pagination.totalPages }">
                    <a class="page-link" href="#" @click.prevent="changePage(pagination.currentPage + 1)">
                        <i class="bi bi-skip-forward"></i>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import api from "@/api";
import SpinnerIOS from "@/components/SiteComponents/Main/Components/SpinnerIOS.vue";

export default {
    name: "CardComponent",
    components: {SpinnerIOS},
    data() {
        return {
            loading: true,
            language: localStorage.getItem('language') || 'uz',
            dataNews: [],
            pagination: {
                currentPage: 1,
                totalPages: 1,
            },
        }
    },
    methods: {
        async fetchNews(page = 1) {
            this.loading = true;
            try {
                localStorage.setItem('currentPage', page);
                const {data} = await api.get(`/news/?page=${page}`, {
                    headers: {
                        'Accept-Language': this.language,
                    },
                });
                this.dataNews = data.results;
                this.pagination.currentPage = page;
                this.pagination.totalPages = Math.ceil(data.count / 12); // assuming 12 per page
            } catch (error) {
                console.error("Xatolik:", error);
            } finally {
                this.loading = false;
            }
        },
        changePage(page) {
            if (page >= 1 && page <= this.pagination.totalPages) {
                this.fetchNews(page);
            }
        },
        goToDetail(id) {
            this.$emit('showEventDetail', id);
        },
        formatDate(dateString) {
            if (!dateString) return 'Sana mavjud emas';
            const date = new Date(dateString);
            if (isNaN(date)) return 'Noto‘g‘ri sana';

            if (this.language === 'uz') {
                const months = [
                    'yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun',
                    'iyul', 'avgust', 'sentyabr', 'oktyabr', 'noyabr', 'dekabr'
                ];
                const day = date.getDate();
                const month = months[date.getMonth()];
                const year = date.getFullYear();
                return `${day}-${month}, ${year}`;
            }

            const options = {year: 'numeric', month: 'long', day: 'numeric'};
            const locale = this.language === 'ru' ? 'ru-RU' : 'en-US';
            return new Intl.DateTimeFormat(locale, options).format(date);
        }
    },
    mounted() {
        const savedPage = parseInt(localStorage.getItem('currentPage')) || 1;
        this.fetchNews(savedPage);
    },
    computed: {
        totalPages() {
            return Math.ceil(this.count / this.pageSize);
        },
        paginationPages() {
            const total = this.pagination.totalPages;
            const current = this.pagination.currentPage;
            const delta = 2;
            const range = [];
            const rangeWithDots = [];
            let l;

            for (let i = 1; i <= total; i++) {
                if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
                    range.push(i);
                }
            }

            for (let i of range) {
                if (l) {
                    if (i - l === 2) {
                        rangeWithDots.push(l + 1);
                    } else if (i - l !== 1) {
                        rangeWithDots.push('...');
                    }
                }
                rangeWithDots.push(i);
                l = i;
            }
            return rangeWithDots;
        }
    },
}
</script>

<style scoped>
.section-cards {
    opacity: 0;
    animation: fadeInUp 0.6s ease-out forwards;
    animation-delay: 0.2s;
}

.card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
}

.card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

.card .position-relative {
    position: relative;
    overflow: hidden;
}

.card-img-top {
    transition: transform 0.3s ease;
    z-index: 1;
}

.card:hover .card-img-top {
    transform: scale(1.05);
    z-index: 1;
}

.overlay {
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease, background-color 0.3s ease;
    opacity: 0;
    z-index: 2;
}

.card:hover .overlay {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.4);
}

.card-title {
    font-size: 1.1rem;
    color: #212529;
}

.card-footer {
    padding-bottom: 1rem;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 768px) {
    .card-title {
        font-size: 1rem;
    }

    .card-img-top {
        height: 150px;
    }
}

/* Pagination styles (retained from original CardComponent) */
.pagination {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 20px;
}

.page-item .page-link {
    color: #6c757d;
    border: 1px solid #dee2e6;
    margin: 0 4px;
    border-radius: 5px;
    transition: background-color 0.2s ease-in-out;
}

.page-item .page-link:hover {
    background-color: #e9ecef;
}

.page-item.active .page-link {
    background-color: #6c757d !important;
    color: white;
    border-color: #6c757d;
}

.page-item.disabled .page-link {
    color: #adb5bd;
    pointer-events: none;
    background-color: #f8f9fa;
}

.page-link:focus {
    box-shadow: none;
    outline: none;
    border: none;
}
</style>